import { gql } from "@apollo/client";

export const SOURCES = gql`
  query Sources(
    $where: SourceWhereInput
    $like: SourceWhereInput
    $take: Int
    $skip: Int
  ) {
    sources(where: $where, take: $take, skip: $skip, like: $like) {
      data {
        id
        name
        platform
      }
      count
    }
  }
`;

export const SOURCE = gql`
  query Source($where: SourceWhereInput) {
    source(where: $where) {
      id
      name
      platform
      leadTypologyMapping
    }
  }
`;

export const LEAD_TYPOLOGY_REVIEW = gql`
  query LeadTypologyReview($sourceId: ID!) {
    leadTypologyReview(sourceId: $sourceId) {
      unmapped {
        rawLabel
        count
      }
      replayable {
        rawLabel
        count
        label
        ignored
      }
    }
  }
`;

export const ADMIN_SOURCES = gql`
  query AdminSources(
    $where: SourceWhereInput
    $like: SourceWhereInput
    $take: Int
    $skip: Int
    $baseUrl: String!
  ) {
    sources(where: $where, take: $take, skip: $skip, like: $like) {
      data {
        id
        name
        platform
        leadTypologyMapping
        fixed
        startDate
        endDate
        archivedAt
        status
        guestLink(baseUrl: $baseUrl)
        authenticatedLink(baseUrl: $baseUrl)
        process {
          id
          name
        }
      }
      count
    }
  }
`;

export const SOURCE_TRACER = gql`
  query SourceTracer($where: SourceWhereInput) {
    source(where: $where) {
      id
      tracer {
        id
      }
    }
  }
`;

export const SOURCE_AVAILABILITY = gql`
  query SourceAvailability($where: SourceWhereInput!) {
    sourceAvailability(where: $where) {
      status
      startDate
      endDate
    }
  }
`;

export const CANVAS_GUEST_SOURCES = gql`
  query CanvasGuestSources($where: SourceWhereInput, $baseUrl: String!) {
    sources(where: $where) {
      data {
        id
        name
        platform
        status
        guestLink(baseUrl: $baseUrl)
      }
    }
  }
`;

export const AVAILABLE_SOURCES = gql`
  query AvailableSources($where: SourceWhereInput) {
    sources(where: $where) {
      data {
        id
        name
        startDate
        endDate
        archivedAt
      }
    }
  }
`;

const sources = {
  SOURCES,
  SOURCE,
  LEAD_TYPOLOGY_REVIEW,
  ADMIN_SOURCES,
  SOURCE_TRACER,
  SOURCE_AVAILABILITY,
  AVAILABLE_SOURCES,
  CANVAS_GUEST_SOURCES,
};

export default sources;
